import React, { useState, useEffect } from 'react';
import Nav from './Nav';
import Occupancy from './Occupancy';
import FootFall from './FootFall';
import Legend from './Legend';
import Tech from './Tech';
import RmsG05Occupancy from './RmsG05Occupancy';
import RMSOccupancy from './RMSOccupancy';
import RMSOccupancyStatus from './RMSOccupancyStatus';


const Home = () => {
  const [currentFootFallCount, setCurrentFootFallCount] = useState(0); // For FootFall
  const [currentRMSCount, setCurrentRMSCount] = useState(0); // For RMSOccupancy
  const [data, setData] = useState(null); // API data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const currentDate = new Date();
  const formattedDate = `${currentDate.getDate()} ${currentDate.toLocaleString('default', { month: 'long' })} ${currentDate.getFullYear()}, ${currentDate.toLocaleString('default', { weekday: 'long' })}`;

  const fetchData = async () => {
    try {
      const response = await fetch('https://optimusb.flowfuse.cloud/HKU_live');
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const result = await response.json();
      console.log("API response", result); // Log the API response
      

      setData(result[0]);
      setError(null); // Reset error on successful fetch
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
      }
    };

  // Fetch data initially and then every 10 seconds
  useEffect(() => {
    fetchData(); // Initial fetch
    const interval = setInterval(() => {
      fetchData();
    }, 10000); // Update every 10 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  if (loading) return <p className='text-[#232383] text-xl font-semibold'>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  const maxCapacity = 12; // desks 

  return (
    <div className="pt-16 lg:pt-20 w-full mb-8 ">
      <Nav />
      <div className="flex items-center justify-between mt-3">
        <div className='md:ml-2 lg:ml-0 xl:ml-0 2xl:ml-0 sm:ml-2 ml-2'>
          <p className="header-title text-[24px] sm:text-[22px] md:text-[28px] lg:text-[32px] xl:text-[32px] font-bold">Live Occupancy</p>
          <p className="text-[18px] sm:text-[18px] md:text-[28px] lg:text-[22px] xl:text-[22px] font-semibold text-[#3450ad] mt-1">{formattedDate}</p>
        </div>
      </div>
  
      <div className="flex flex-col xl:flex-row items-start mt-14 space-y-6 md:space-y-0 lg:space-y-0 xl:space-y-0 xl:space-x-16 2xl:space-x-36">
        {/* 4 components in 2 rows for smaller screens */}
        <div className="flex flex-col xl:flex-col space-y-6 lg:mb-11 md:mb-10 sm:mb-3 mb-3 sm:flex-col sm:mx-auto mx-auto">
          {/* First Row for smaller screens */}
          <div className="flex flex-col sm:flex-col md:flex-row lg:flex-row xl:flex-col md:space-x-8 lg:space-x-8 xl:space-x-0 xl:space-y-6 sm:space-y-6 lg:space-y-0 md:space-y-0  space-y-6 ">
            <Tech occupancy={data?.technology_area?.occupancy ?? 'N/A'} />
            {/* <FootFall currentCount={currentFootFallCount} maxCapacity={maxCapacity} /> */}
          </div>
          {/* Second Row for smaller screens */}
          <div className="flex flex-col mt-6 xl:mt-0 md:flex-row lg:flex-row md:space-x-0 lg:space-x-8 xl:space-x-0  xl:flex-col sm:flex-col xl:space-y-6 sm:space-y-6 md:space-y-0  lg:space-y-4 space-y-6 ">
          <FootFall currentCount={currentFootFallCount} maxCapacity={maxCapacity} />
            {/* <RmsG05Occupancy data={data?.RMS?.occupancy ?? 'N/A'} /> */}
            {/* <Legend /> */}
          </div>
        </div>
  
        {/*  xl and above, it will be beside the components */}
        <div
          className="relative flex xl:w-[978px] xl:h-[538px] lg:w-[810px] lg:h-[445px] md:w-[780px] md:h-[430px] sm:w-[604px] sm:h-[333px] w-[356px] h-[196px] md:mx-auto bg-cover bg-center mt-8 "
          style={{ backgroundImage: "url('/planf.png')" }}
        >
          <div className="xl:pl-[330px] xl:pt-[80px] lg:pl-[266px] lg:pt-[62px] md:pl-[256px] md:pt-[62px] sm:pl-[186px] sm:pt-[44px] pl-[110px] pt-[28px]">
          <Occupancy occupancyData={data?.[0]?.occupancy} setCurrentCount={setCurrentFootFallCount} />
          </div>

        </div>
        
      </div>

      <div className="flex mt-8 xl:mt-10 lg:mt-10 md:mt-8 sm:mt-8  flex-col xl:flex-row justify-between gap-x-14 items-start w-full 2xl:space-x-24">
      {/* RMSOccupancyStatus*/}
      <div className="w-full xl:w-auto xl:mb-10 lg:mb-10 md:mb-8 sm:mb-8 mb-8 ">
        <RMSOccupancyStatus currentCount={currentRMSCount} maxCapacity={30} />
      </div>

      
      <div
        className="relative flex  xl:w-[974px] xl:h-[484px] lg:w-[802px] lg:h-[399px] md:w-[774px] md:h-[384px] sm:w-[600px] sm:h-[298px] w-[350px] h-[174px] lg:mx-auto md:mx-auto bg-cover bg-center "
        style={{ backgroundImage: "url('/RMS.svg')" }}
      >
        <div className="absolute">
          <RMSOccupancy setCurrentCount={setCurrentRMSCount} />
        </div>
      </div>
    </div>

    </div>
    
  );
};

export default Home;
